// 業者一覧画面
import React, { useState, useEffect, useCallback, useRef } from 'react';
import './List.css';
import '../App.css';
import {
  useMediaQuery,
  FormControl,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Snackbar,
  DialogContent,
  DialogContentText,
  Dialog,
  DialogActions,
  DialogTitle,
  Tooltip
} from '@material-ui/core';
import { DialogProps } from '@material-ui/core/Dialog';
import {
  makeStyles,
  withStyles,
  createStyles,
  Theme
} from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import DeleteIcon from '@material-ui/icons/Delete';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useHistory, Redirect } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import {
  mainBlueColor,
  btnColor,
  isLoggedIn,
  vendorData,
  vendorTypeLargeRecoilData,
  vendorRankRecoilData
} from '../GlobalState';
import {
  getVendorList,
  getVendorTypeLarge,
  deleteVendor,
  getExportVendorItems,
  getVendorRank
} from '../apicalls/getVendorDetails';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import LoadingComponent from '../components/LoadingComponent';
import { CSVLink } from 'react-csv';
import PaginationComponent from '../components/PaginationComponent';
import { BasicSelect } from '../components/parts/input/BasicSelect';
import { TParams } from '../types/VendorList';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';
import { getPartnerCategories } from '../apicalls/partnerCategory';
import { TCategoryDetailItem, TCategoryItem } from '../types/partnerCategory';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);

interface State {
  arr: any;
}

interface CheckedState {
  check: any;
}

export const VendorList: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);

  const [errorMessage, setErrorMessage] = useState('');
  const [count, setCount] = useState(0);
  const [name, setName] = useState('');
  const [tel, setTel] = useState('');
  const [prefecture, setPrefecture] = useState('');
  const [address, setAddress] = useState('');
  const [selectedPartnerTypeLargeId, setSelectedPartnerTypeLargeId] =
    useState(0);
  const [selectedPartnerTypeSmallId, setSelectedPartnerTypeSmallId] =
    useState(0);
  const [selectedPartnerTypeDetailId, setSelectedPartnerTypeDetailId] =
    useState(0);
  // MEMO: ランクIDの対応
  /*
  0: ランクなし
  1: A
  2: B
  3: C
  */
  const [selectedRankId, setSelectedRankId] = useState(0);

  const [vendorTypeLargeApiData, setVendorTypeLargeApiData] = useRecoilState(
    vendorTypeLargeRecoilData
  );
  const [vendorRankApiData, setVendorRankApiData] =
    useRecoilState(vendorRankRecoilData);
  const changeVendorTypeLargeApiData = useCallback(
    (newData: any) => setVendorTypeLargeApiData(newData),
    [setVendorTypeLargeApiData]
  );

  const changeVendorRankApiData = useCallback(
    (newData: any) => setVendorRankApiData(newData),
    [setVendorRankApiData]
  );
  const [vendorApiData, setVendorApiData] = useRecoilState(vendorData);
  const changeVendorApiData = useCallback(
    (newData: any) => setVendorApiData(newData),
    [setVendorApiData]
  );

  const [loading, setLoading] = useState(vendorApiData !== null ? false : true);
  const [apiData, setApiData] = useState<any>(
    vendorApiData !== null ? vendorApiData : []
  );
  // 業種（大項目、小項目）
  const [categoryItems, setCategoryItems] = useState<TCategoryItem[]>([]);
  const flattenedCategoryDetails = categoryItems.flatMap(
    categoryItem => categoryItem.category_detail || []
  );
  const [vendorTypeLargeData, setVendorTypeLargeData] = useState<any>(
    vendorTypeLargeApiData !== null ? vendorTypeLargeApiData : []
  );
  const [vendorRankData, setVendorRankData] = useState<any>(
    vendorRankApiData !== null ? vendorRankApiData : []
  );

  const [vendorIds, setVendorIds] = useState<State>({ arr: [] });
  const [checked, setChecked] = useState<CheckedState>({ check: [] });
  const [pressed, setPressed] = useState([]);
  const [isSelected, setSelection] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [displayLimit, setDisplayLimit] = useState<number>(10);

  async function getVendorListHavingParams() {
    // 検索条件が保持されているとき、検索結果のリクエストを遅らせる

    let promise = new Promise((resolve, reject) => {
      setTimeout(() => resolve('done'), 300);
    });

    let result = await promise; // promiseが解決するまで(300ms)待つ

    getVendorList({
      name: name.trim(),
      tel: tel.trim(),
      prefecture_name: prefecture.trim(),
      address: address,
      partner_type_large_id: selectedPartnerTypeLargeId,
      partner_type_small_id: selectedPartnerTypeSmallId,
      partner_type_detail_id: selectedPartnerTypeDetailId,
      rank_id: selectedRankId,
      current_page: currentPage,
      display_limit: displayLimit
    }).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            changeVendorApiData(data.data);
            setApiData(data.data);
            setCount(data.data.length);
            setLoading(false);
            setVendorIds({ arr: [] });
            setChecked({ check: [] });
            setSelection(false);
            setPageCount(data.page_count);
            setMyCheckExport(data.selected_columns);
          }
        }
      }
    });
  }

  const [openModal, setOpenModal] = useState(false);

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [openAlert, setOpenAlert] = useState(false);
  const [myCheckExport, setMyCheckExport] = useState<any>([]);
  const [transactionData, setTransactionData] = useState<any>([]);
  const [params, setParams] = useState<TParams>();
  const csvLink: any = useRef();

  const checkListOptions = [
    { large_type: '業者種別' },
    { small_type: '業種（大項目）' },
    { business_type_ids: '業種（小項目）' },
    { name: '会社名' },
    { furigana: 'ふりがな' },
    { person_in_charge_name: '担当者' },
    { person_in_charge_tel: '担当者TEL' },
    { person_in_charge_email: '担当者メールアドレス' },
    { prefecture: '都道府県' },
    { rep_name: '代表者氏名' },
    { capital: '資本金' },
    { no_of_employees: '社員数' },
    { tel: 'TEL' },
    { fax: 'FAX' },
    { address1: '本所所在地' },
    { address2: '事業所所在地' },
    { address3: '他の場所' },
    { bank_name: '銀行名' },
    { bank_branch: '支店名' },
    { account_type: '口座種別' },
    { account_number: '口座番号' },
    { account_name: '名義人' },
    { end_day: '締日' },
    { payment_site: '支払いサイト' },
    { remarks: '備考' },
    { rank: 'ランク' }
  ];
  // account_name: "nominee"{"business_type_ids":"業種（小項目）"},{"furigana":"ふりがな"},{"person_in_charge_name":"担当者"},{"erson_in_charge_tel":"担当者TEL"},{"person_in_charge_email":"担当者メールアドレス"},{"prefecture":"都道府県"},{"rep_name":"代表者氏名"},{"capital":"資本金"},{"no_of_employees":"社員数"},{"tel":"TEL"},{"fax":"FAX"},{"address1":"本所所在地"},{"address2":"事業所所在地"},{"address3":"他の場所"},{"bank_name":"銀行名"},{"bank_branch":"支店名"},{"account_type":"口座種別"},{"account_number":"口座番号"},{"account_name":"名義人"},{"payment_site_date":"支払いサイト"},{"end_day":"締日"},{"remarks":"備考"}

  const getListOfVendors = useCallback(() => {
    if (
      params?.name != undefined ||
      params?.tel != undefined ||
      params?.prefecture != undefined ||
      params?.address != undefined ||
      params?.selectedPartnerTypeLargeId != undefined ||
      params?.selectedPartnerTypeSmallId != undefined ||
      params?.selectedPartnerTypeDetailId != undefined ||
      params?.selectedRankId != undefined
    ) {
      getVendorListHavingParams();
    } else {
      getVendorList({
        name: name.trim(),
        tel: tel.trim(),
        prefecture_name: prefecture.trim(),
        address: address,
        partner_type_large_id: selectedPartnerTypeLargeId,
        partner_type_small_id: selectedPartnerTypeSmallId,
        partner_type_detail_id: selectedPartnerTypeDetailId,
        rank_id: selectedRankId,
        current_page: currentPage,
        display_limit: displayLimit
      }).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              changeVendorApiData(data.data);
              setApiData(data.data);
              setCount(data.data.length);
              setLoading(false);
              setVendorIds({ arr: [] });
              setChecked({ check: [] });
              setSelection(false);
              setPageCount(data.page_count);
              setMyCheckExport(data.selected_columns);
            }
          }
        }
      });
    }
  }, [
    changeLoggedInData,
    changeVendorApiData,
    params,
    currentPage,
    displayLimit
  ]);

  // 業種（大項目、小項目）一覧を取得
  const getAllPartnerCategories = useCallback(() => {
    getPartnerCategories().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setCategoryItems(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData, setCategoryItems]);

  // 業者種別一覧を取得
  const getAllVendorTypeLarge = useCallback(() => {
    getVendorTypeLarge().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            changeVendorTypeLargeApiData(data.data);
            setVendorTypeLargeData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData, changeVendorTypeLargeApiData]);

  const getAllVendorRank = useCallback(() => {
    getVendorRank().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            changeVendorRankApiData(data.data);
            setVendorRankData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData, changeVendorRankApiData]);

  const handleClickOpenAlert = () => {
    setOpenAlert(true);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const deleteSelectedVendors = () => {
    deleteVendor(vendorIds.arr).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setOpenAlert(false);
            getListOfVendors();
          }
        }
      }
    });
  };

  useEffect(() => {
    getAllVendorTypeLarge();
    getAllPartnerCategories();
    getAllVendorRank();
  }, [getAllVendorTypeLarge, getAllPartnerCategories, getAllVendorRank]);

  useEffect(() => {
    setCurrentPage(1);
  }, [
    name,
    tel,
    prefecture,
    address,
    selectedPartnerTypeLargeId,
    selectedPartnerTypeSmallId,
    selectedPartnerTypeDetailId,
    selectedRankId,
    params
  ]);

  useEffect(() => {
    getListOfVendors();
  }, [
    name,
    tel,
    prefecture,
    address,
    selectedPartnerTypeLargeId,
    selectedPartnerTypeSmallId,
    selectedPartnerTypeDetailId,
    selectedRankId,
    params,
    currentPage,
    displayLimit
  ]);

  useEffect(() => {
    // 画面遷移の際のステートがなければ処理しない
    if (!history.location.state) return;

    // パラメーター取得
    const params: TParams | undefined = history.location.state.params;
    setParams(params);

    if (params) {
      setName(params.name ? params.name : ''); // 名前設定
      setSelectedPartnerTypeLargeId(
        params.selectedPartnerTypeLargeId
          ? params.selectedPartnerTypeLargeId
          : 0
      ); // 業者種別設定
      setSelectedPartnerTypeSmallId(
        params.selectedPartnerTypeSmallId
          ? params.selectedPartnerTypeSmallId
          : 0
      ); // 業種（大項目）設定
      setSelectedPartnerTypeDetailId(
        params.selectedPartnerTypeDetailId
          ? params.selectedPartnerTypeDetailId
          : 0
      ); // 業種（小項目）設定
      setTel(params.tel ? params.tel : ''); // 電話番号設定
      setPrefecture(params.prefecture ? params.prefecture : ''); // 都道府県設定
      setAddress(params.address ? params.address : ''); // 所在地設定
      setSelectedRankId(params.selectedRankId ? params.selectedRankId : 0); // ランク設定
    }
  }, []);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'scroll'
      },
      paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        paddingTop: 30,
        paddingBottom: 30,
        marginTop: 30,
        marginBottom: 30
      },

      formControl: {
        minWidth: 120,
        backgroundColor: '#FFFFFF'
      },
      formControl1: {
        minWidth: 120,
        height: 30,
        borderRadius: 5,
        borderWidth: 1,
        paddingLeft: 5
      },
      main: {
        minWidth: 700
      },
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        padding: 8,
        fontSize: 16,
        fontWeight: 'bold'
      },
      input: {
        borderColor: '#CCCCCC',
        padding: 5,
        margin: 10
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      },
      table1: {
        padding: 8
      }
    })
  );

  function handleChange(index: number) {
    for (let i = 0; i < count; i++) {
      if (checked.check[i] === false) {
        setSelection(false);
      }
    }

    let checkedBox: any = [...checked.check];
    checkedBox[index] = !checked.check[index];
    setChecked({ check: checkedBox });
  }

  const matches2 = useMediaQuery('(min-width:900px)');
  const classes = useStyles();
  const history: any = useHistory();

  const [checkBoxSelected, setCheckBoxSelected] = useState(false);

  const [open, setOpen] = React.useState(false);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const selectAllCheckBoxPressed = () => {
    let a = [];
    if (isSelected === false) {
      // subject ids
      let subjectArray: any = [];
      setVendorIds({ arr: [] });

      setChecked({ check: [] });
      setPressed([]);
      for (let i = 1; i <= count; i++) {
        a.push(true);
        setChecked({ check: a });
      }

      apiData.map((item: any, k: number) => subjectArray.push(item.id));
      setVendorIds({ arr: subjectArray });
    } else {
      setVendorIds({ arr: [] });
      for (let i = 1; i <= count; i++) {
        a.push(false);
        setChecked({ check: a });
      }
    }
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleExport = () => {
    getExportVendorItems(
      myCheckExport,
      name.trim(),
      tel.trim(),
      prefecture.trim(),
      address,
      selectedPartnerTypeLargeId,
      selectedPartnerTypeSmallId,
      selectedRankId
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setTransactionData(data.rows_list);
            csvLink.current.link.click();
            handleCloseModal();
          }
        }
      }
    });
  };
  const [fullWidth] = useState(true);
  const [maxWidth] = useState<DialogProps['maxWidth']>('sm');

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <AppBarComponent patternName={'vendors'} />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            backgroundColor: '#F5F5F5',
            padding: 15,
            minHeight: window.innerHeight - 150
          }}
        >
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>

          <div className={matches2 ? 'main-container-customer' : ''}>
            <div
              className={
                matches2
                  ? 'top-Container-customer'
                  : 'top-Container-customer-responsive'
              }
              style={{ gap: 10, paddingLeft: 0 }}
            >
              <input
                style={{
                  marginRight: 20,
                  marginBottom: 10,
                  backgroundColor: '#FFFFFF'
                }}
                className={classes.formControl1}
                placeholder='会社名'
                value={name}
                maxLength={20}
                onChange={e => {
                  setName(e.target.value);
                  setParams(prevParams => ({
                    ...prevParams,
                    name: e.target.value
                  }));
                }}
              />

              <div
                style={{
                  marginRight: 20,
                  marginBottom: 10
                }}
                className='select-div'
              >
                <div>
                  <FormControl className={classes.formControl}>
                    <BasicSelect
                      value={selectedPartnerTypeLargeId}
                      onChange={(e: any) => {
                        setSelectedPartnerTypeLargeId(e.target.value);
                        setParams(prevParams => ({
                          ...prevParams,
                          selectedPartnerTypeLargeId: e.target.value
                        }));
                      }}
                      style={{ paddingLeft: 5 }}
                      inputProps={{ 'aria-label': 'age' }}
                      disableUnderline
                    >
                      <option value={0}>業者種別</option>
                      {vendorTypeLargeData.map((i: any) => (
                        <option value={i.id}>{i.name}</option>
                      ))}
                    </BasicSelect>
                  </FormControl>
                </div>
              </div>

              <div
                style={{
                  marginRight: 20,
                  marginBottom: 10,
                  height: '35px'
                }}
                className='select-div'
              >
                <div>
                  <FormControl className={classes.formControl}>
                    <Autocomplete
                      style={{ minWidth: '170px' }}
                      options={categoryItems}
                      getOptionLabel={option => option.name}
                      value={
                        categoryItems.find(
                          item => item.id === selectedPartnerTypeSmallId
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        setSelectedPartnerTypeSmallId(
                          newValue ? newValue.id : 0
                        );
                        setParams(prevParams => ({
                          ...prevParams,
                          selectedPartnerTypeSmallId: newValue ? newValue.id : 0
                        }));
                      }}
                      renderInput={params => (
                        <TextField
                          style={{ minWidth: '170px' }}
                          {...params}
                          label='業種（大項目）'
                          variant='outlined'
                          placeholder='選択してください'
                        />
                      )}
                    />
                  </FormControl>
                </div>
              </div>

              <div
                style={{
                  marginRight: 20,
                  marginBottom: 10,
                  height: '35px'
                }}
                className='select-div'
              >
                <div>
                  <FormControl className={classes.formControl}>
                    <Autocomplete
                      style={{ minWidth: '170px' }}
                      options={flattenedCategoryDetails}
                      getOptionLabel={option => option.name}
                      value={
                        flattenedCategoryDetails.find(
                          item => item.id === selectedPartnerTypeDetailId
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        setSelectedPartnerTypeDetailId(
                          newValue ? newValue.id : 0
                        );
                        setParams(prevParams => ({
                          ...prevParams,
                          selectedPartnerTypeDetailId: newValue
                            ? newValue.id
                            : 0
                        }));
                      }}
                      renderInput={params => (
                        <TextField
                          {...params}
                          label='業種（小項目）'
                          variant='outlined'
                          placeholder='選択してください'
                        />
                      )}
                    />
                  </FormControl>
                </div>
              </div>

              <input
                style={{
                  marginRight: 20,
                  marginBottom: 10,
                  backgroundColor: '#FFFFFF'
                }}
                className={classes.formControl1}
                placeholder='電話番号'
                value={tel}
                maxLength={20}
                onChange={e => {
                  setTel(e.target.value);
                  setParams(prevParams => ({
                    ...prevParams,
                    tel: e.target.value
                  }));
                }}
              />
              <input
                style={{
                  marginRight: 20,
                  marginBottom: 10,
                  backgroundColor: '#FFFFFF'
                }}
                className={classes.formControl1}
                placeholder='都道府県'
                value={prefecture}
                maxLength={5}
                onChange={e => {
                  setPrefecture(e.target.value);
                  setParams(prevParams => ({
                    ...prevParams,
                    prefecture: e.target.value
                  }));
                }}
              />
              <input
                style={{
                  marginRight: 20,
                  marginBottom: 10,
                  backgroundColor: '#FFFFFF'
                }}
                className={classes.formControl1}
                placeholder='市区町村・番地など'
                value={address}
                maxLength={120}
                onChange={e => {
                  setAddress(e.target.value);
                  setParams(prevParams => ({
                    ...prevParams,
                    address: e.target.value
                  }));
                }}
              />
              <div
                style={{
                  marginRight: 20,
                  marginBottom: 10
                }}
                className='select-div'
              >
                <div>
                  <FormControl className={classes.formControl}>
                    <BasicSelect
                      value={selectedRankId}
                      onChange={(e: any) => {
                        setSelectedRankId(e.target.value);
                        setParams(prevParams => ({
                          ...prevParams,
                          selectedRankId: e.target.value
                        }));
                      }}
                      style={{ paddingLeft: 5 }}
                      inputProps={{ 'aria-label': 'rank' }}
                      disableUnderline
                    >
                      <option value={0}>ランク</option>
                      {vendorRankData.map((i: any) => (
                        <option value={i.id}>{i.name}</option>
                      ))}
                    </BasicSelect>
                  </FormControl>
                </div>
              </div>
              <Button
                style={{
                  marginRight: 20,
                  marginBottom: 10,
                  backgroundColor: buttonColor
                }}
                variant='contained'
                color='primary'
                onClick={() => {
                  getListOfVendors();
                  setCurrentPage(1);
                }}
              >
                検索
              </Button>
            </div>
          </div>

          <div
            style={{ padding: 15, backgroundColor: '#FFFFFF', borderRadius: 5 }}
          >
            <div className='table-top-container-customer'>
              <div style={{ fontWeight: 'bold' }}>業者一覧</div>
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <div
                  style={{
                    marginRight: 10,
                    paddingLeft: 5,
                    marginBottom: !matches2 ? 10 : 0
                  }}
                  className='select-div'
                >
                  <FormControl className={classes.formControl}>
                    <BasicSelect
                      value={displayLimit}
                      onChange={e => {
                        setCurrentPage(1);
                        setDisplayLimit(parseInt(e.target.value));
                      }}
                      inputProps={{ 'aria-label': 'age' }}
                      disableUnderline
                    >
                      <option value={10}>10件</option>
                      <option value={30}>30件</option>
                      <option value={50}>50件</option>
                    </BasicSelect>
                  </FormControl>
                </div>
                <Button
                  style={{
                    backgroundColor: buttonColor,
                    marginRight: 10,
                    marginBottom: !matches2 ? 10 : 0
                  }}
                  variant='contained'
                  color='secondary'
                  startIcon={<NoteAddIcon />}
                  onClick={() => {
                    history.push('/vendors/create', {
                      params: params
                    });
                  }}
                >
                  新規作成
                </Button>

                <CustomTooltip
                  title={tooltipContents.vendorsSelectDelete}
                  placement='top'
                >
                  <Button
                    style={{
                      backgroundColor: buttonColor,
                      marginRight: 10,
                      marginBottom: !matches2 ? 10 : 0
                    }}
                    variant='contained'
                    color='secondary'
                    onClick={() => {
                      if (vendorIds.arr.length <= 0) {
                        alert('対象を選択してください。');
                      } else {
                        handleClickOpenAlert();
                      }
                    }}
                    startIcon={<DeleteIcon />}
                  >
                    選択削除
                  </Button>
                </CustomTooltip>
                {/* <CSVLink
                  data={exportData}
                  filename={"工事一覧.csv"}
                  target="_blank"
                  style={{ textDecorationLine: "none" }}
                > */}
                <CustomTooltip
                  title={tooltipContents.vendorsListExport}
                  placement='top'
                >
                  <Button
                    style={{
                      backgroundColor: buttonColor,
                      marginBottom: !matches2 ? 10 : 0
                    }}
                    onClick={handleOpenModal}
                    variant='contained'
                    color='secondary'
                    startIcon={<GetAppIcon />}
                  >
                    エクスポート
                  </Button>
                </CustomTooltip>
                {/* </CSVLink> */}
              </div>
            </div>
            <Dialog
              fullWidth={fullWidth}
              maxWidth={maxWidth}
              open={openModal}
              onClose={handleCloseModal}
              aria-labelledby='max-width-dialog-title'
            >
              <DialogContent>
                <DialogContentText id='alert-dialog-description'>
                  <div>
                    <div
                      className='border1'
                      style={{ display: 'flex', flexDirection: 'row' }}
                    >
                      <div style={{ flex: 3 }}>
                        <div
                          style={{ padding: 10, backgroundColor: mainColor }}
                        >
                          <div style={{ color: '#FFFFFF' }}>エクスポート</div>
                        </div>
                      </div>
                    </div>

                    {checkListOptions.map((i: any, index) => (
                      <div
                        className='border1'
                        style={{ display: 'flex', flexDirection: 'row' }}
                      >
                        <div
                          style={{
                            flex: 3,
                            backgroundColor:
                              index % 2 === 0 ? '#F5F5F5' : '#FFFFFF'
                          }}
                        >
                          <div style={{ padding: 3 }}>
                            <Checkbox
                              name='expertCheckbox'
                              checked={
                                myCheckExport.includes(
                                  Object.keys(i).toString()
                                )
                                  ? true
                                  : false
                              }
                              onClick={e => {
                                var ind = myCheckExport.indexOf(
                                  Object.keys(i).toString()
                                );
                                if (ind === -1) {
                                  setMyCheckExport([
                                    ...myCheckExport,
                                    Object.keys(i).toString()
                                  ]);
                                } else {
                                  setMyCheckExport(
                                    myCheckExport.filter(
                                      (char: any, aa: any) => aa !== ind
                                    )
                                  );
                                }
                              }}
                              style={{
                                color: myCheckExport.includes(
                                  Object.keys(i).toString()
                                )
                                  ? buttonColor
                                  : '#758283'
                              }}
                            />
                            {Object.values(i)}
                          </div>
                        </div>
                      </div>
                    ))}
                    <div></div>
                  </div>
                </DialogContentText>
              </DialogContent>
              <div
                style={{
                  marginBottom: 20,
                  marginTop: 10,
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <Button
                  style={{ backgroundColor: buttonColor }}
                  variant='contained'
                  color='primary'
                  onClick={() => {
                    handleExport();
                    // handleCloseModal();
                  }}
                  startIcon={<GetAppIcon />}
                >
                  保存
                </Button>
                <CSVLink
                  data={transactionData}
                  filename='業者一覧.csv'
                  className='hidden'
                  ref={csvLink}
                  target='_blank'
                />
              </div>
            </Dialog>

            <TableContainer component={Paper}>
              <Table className={classes.main} aria-label='customized table'>
                <TableHead>
                  <TableRow>
                    <StyledTableCell className={classes.table} align='center'>
                      <CustomTooltip
                        title={tooltipContents.selectDelete}
                        placement='top'
                      >
                        <Checkbox
                          checked={isSelected}
                          onClick={() => {
                            setSelection(!isSelected);
                            selectAllCheckBoxPressed();
                          }}
                          style={{
                            color: isSelected ? buttonColor : '#FFFFFF'
                          }}
                        />
                      </CustomTooltip>
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      業者種別
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      業種（大項目）
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      業種（小項目）
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      名前
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      住所
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      支払いサイト
                    </StyledTableCell>
                    {/* <StyledTableCell
                      className={classes.table}
                      align="center"
                    ></StyledTableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {apiData.map((row: any, index: number) => (
                    <StyledTableRow
                      key={row.id}
                      className='click_table_row'
                      title='編集'
                      // onClick={() => {
                      //   history.push(`/vendors/${row.id}/edit`);
                      // }}
                    >
                      <StyledTableCell
                        className={classes.table1}
                        align='center'
                      >
                        <CustomTooltip
                          title={tooltipContents.selectDelete}
                          placement='top'
                        >
                          <Checkbox
                            checked={checked.check[index] ? true : false}
                            onClick={() => {
                              handleChange(index);
                              let newArr = vendorIds.arr;
                              if (!checked.check[index] && !pressed[index]) {
                                newArr.push(row.id);
                                setVendorIds({ arr: newArr });
                              } else {
                                var ind = vendorIds.arr.indexOf(row.id);
                                if (ind !== -1) vendorIds.arr.splice(ind, 1);
                              }
                              setCheckBoxSelected(!checkBoxSelected);
                            }}
                            style={{
                              color: checked.check[index]
                                ? buttonColor
                                : '#758283'
                            }}
                          />
                        </CustomTooltip>
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 120 }}
                        align='center'
                        onClick={() => {
                          history.push(`/vendors/${row.id}/edit`, {
                            params: params
                          });
                        }}
                      >
                        {row.large_type}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 100 }}
                        align='center'
                        onClick={() => {
                          history.push(`/vendors/${row.id}/edit`, {
                            params: params
                          });
                        }}
                      >
                        {row.small_type}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 100 }}
                        align='center'
                        onClick={() => {
                          history.push(`/vendors/${row.id}/edit`, {
                            params: params
                          });
                        }}
                      >
                        {row.detail_type}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 130 }}
                        align='center'
                        onClick={() => {
                          history.push(`/vendors/${row.id}/edit`, {
                            params: params
                          });
                        }}
                      >
                        {row.name}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 100 }}
                        align='center'
                        onClick={() => {
                          history.push(`/vendors/${row.id}/edit`, {
                            params: params
                          });
                        }}
                      >
                        {row.street_address}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 120 }}
                        align='center'
                        onClick={() => {
                          history.push(`/vendors/${row.id}/edit`, {
                            params: params
                          });
                        }}
                      >
                        {row.payment_site}
                      </StyledTableCell>
                      {/* <StyledTableCell
                        className={classes.table1}
                        align="center"
                      >
                        <Button
                          style={{ backgroundColor: buttonColor }}
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            history.push(`/vendors/${row.id}/edit`);
                          }}
                        >
                          編集
                        </Button>
                      </StyledTableCell> */}
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
              {!loading && apiData.length === 0 && (
                <div className={classes.container}>データがありません</div>
              )}
            </TableContainer>
            <PaginationComponent
              page={currentPage}
              pageCount={pageCount}
              setCurrentPage={setCurrentPage}
            />
            <Dialog
              open={openAlert}
              onClose={handleCloseAlert}
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'
            >
              <DialogTitle id='alert-dialog-title'>
                {'選択した業者を削除しますか？'}
              </DialogTitle>
              <DialogActions>
                <Button onClick={handleCloseAlert} color='primary'>
                  キャンセル
                </Button>
                <Button
                  onClick={() => {
                    deleteSelectedVendors();
                  }}
                  color='primary'
                  autoFocus
                >
                  削除
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </div>
      )}
      <FooterComponent />
    </div>
  );
};
